import React from "react";

const BackIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="black" fillOpacity="0.12" />
      <mask
        id="mask0_190_595"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="20"
        height="20"
      >
        <rect x="6" y="6" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_190_595)">
        <path
          d="M12.5189 16.8333L16.6022 20.9167C16.7689 21.0833 16.8487 21.2778 16.8418 21.5C16.8349 21.7222 16.748 21.9167 16.5814 22.0833C16.4147 22.2361 16.2203 22.316 15.998 22.3229C15.7758 22.3299 15.5814 22.25 15.4147 22.0833L9.91471 16.5833C9.83138 16.5 9.77235 16.4097 9.73763 16.3125C9.70291 16.2153 9.68555 16.1111 9.68555 16C9.68555 15.8889 9.70291 15.7847 9.73763 15.6875C9.77235 15.5903 9.83138 15.5 9.91471 15.4167L15.4147 9.91667C15.5675 9.76389 15.7585 9.6875 15.9876 9.6875C16.2168 9.6875 16.4147 9.76389 16.5814 9.91667C16.748 10.0833 16.8314 10.2812 16.8314 10.5104C16.8314 10.7396 16.748 10.9375 16.5814 11.1042L12.5189 15.1667H21.8314C22.0675 15.1667 22.2654 15.2465 22.4251 15.4062C22.5849 15.566 22.6647 15.7639 22.6647 16C22.6647 16.2361 22.5849 16.434 22.4251 16.5937C22.2654 16.7535 22.0675 16.8333 21.8314 16.8333H12.5189Z"
          fill="#2B2B2B"
        />
      </g>
    </svg>
  );
};

export default BackIcon;
